import { connect } from 'react-redux';
import ConnectableInstanceWidgetStatistic from 'client/components/Instance/components/ConnectableInstanceWidgetStatistic';
import { instanceAitdReadStatistics } from 'client/redux/aitd/statisticsActions';
import _ from 'lodash';

const mapStateToProps =  (state, props) => {
  const statistic = props.statistic;
  const id = props.reducerKey;
  return {
    ...(state.aitd.statistics[id] || {}),
    data: _.get(state, ['aitd', 'statistics', id, 'data', statistic], null),
  };
};

const actions = {
  readStatistic: instanceAitdReadStatistics,
};

export default connect(mapStateToProps, actions)(ConnectableInstanceWidgetStatistic);
